<template>
  <div>
    <img
        :src="icons.accountVerification"
        class="account-verification__step__icon verification-method-selection__icon">

    <h1 class="account-verification__step__title">
      Select a verification method.
    </h1>
    <p class="account-verification__step__description">
      How would they like to verify their account?
    </p>

    <verification-method-select
        @methodSelected="setVerificationMethod"
        @verificationChannelsUpdated="propagateAvailableVerificationChannels" />

    <div class="verification-method-selection__step__right-aligned-button-container">
      <el-button
          :disabled="verificationMethod === null"
          type="primary"
          class="account-verification__step__button"
          @click="notifyContinue">
        Continue
      </el-button>
    </div>
  </div>
</template>

<script>
import VerificationMethodSelect from "./VerificationMethodSelect";

export default {
  name: "VerificationMethodSelectionStep",
  components: {
    VerificationMethodSelect,
  },
  emits: ["methodSelected", "nextStepRequested", "verificationChannelsUpdated"],
  data() {
    return {
      verificationMethod: null,
      icons: {
        accountVerification: require("@/assets/icons/action-account-verification.svg"),
      },
    };
  },
  methods: {
    setVerificationMethod(selectedMethod) {
      this.verificationMethod = selectedMethod;
      this.$emit("methodSelected", selectedMethod);
    },
    notifyContinue() {
      this.$emit("nextStepRequested", true);
    },
    propagateAvailableVerificationChannels(channels) {
      this.$emit("verificationChannelsUpdated", channels);
    },
  },
};
</script>

<style scoped>
.verification-method-selection__step__right-aligned-button-container {
  text-align: right;
  margin-top: 135px;
}

.verification-method-selection__icon {
  transform: translate(-12px);
}
</style>
